import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { Gender } from '@enums/gender';
import { TreatmentGenderSettings } from '@models/treatment-types/treatment-gender-settings.model';
import { TreatmentType } from '@models/treatment-types/treatment-type.model';

/**
 * Defines the UTI treatment type.
 */
export const UtiTreatment = new TreatmentType({
  id: '1',
  name: ConsultationTreatmentTypes.Uti,
  genderSettings: new TreatmentGenderSettings({
    disallowed: [Gender.Male],
    errorMessage: 'Yeast Infection and UTI treatments are only available for female patients.',
  }),
});
